/* eslint-disable react/no-array-index-key */
/* eslint-disable max-len */

import { FieldArray, Form, Formik } from 'formik';
import React, { useState } from 'react';
import clsx from 'clsx';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import style from './PoltroneForm.module.scss';
import { setPoltroneData } from '../../../../app/slices/poltroneSlice';
import PoltroneTile from '../PoltroneTile/PoltroneTile';
import PrimaryButton from '../../../../components/Buttons/PrimaryButton/PrimaryButton';
import store from '../../../../app/store/store';
import api from '../../../../core/api';

function PoltroneForm() {
  const [state, setState] = useState({});
  const [buttonText, setButtonText] = useState('Salva');
  const initialValues = {
    poltrone: [
      { nome: 'Marione', idPoltrona: 0 },
    ],
  };

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const handleNextStep = async (values) => {
    await dispatch(setPoltroneData(values));
    await setState({
      form: store.getState().form.form,
      giorni: store.getState().orari.giorni,
      servizi: store.getState().servizi.servizi,
      poltrone: store.getState().poltrone.poltrone,
    });
    api.post('/business/auth/autoSignUp', state).then((res) => (res.status === 200 ? navigate('/riepilogo') : setButtonText('Riprova')));
  };

  return (
    <Formik
      initialValues={initialValues}
      onSubmit={async (values) => {
        handleNextStep(values);
      }}
    >
      {({ values, setFieldValue }) => (
        <Form className={clsx(style.form)}>
          <div className={clsx(style.form__header)}>
            <h2 className={clsx(style.page__title)}>
              Poltrone
            </h2>
            <h3 className={clsx(style.page__subtitle)}>
              Inserisci i nomi dei barbieri che riceveranno le prenotazioni su Zetabarber
            </h3>
            <FieldArray name="poltrone">
              {() => (
                values.poltrone.map((poltrona, index) => (
                  <PoltroneTile
                    poltrone={values.poltrone}
                    idPoltrona={poltrona.idPoltrona}
                    setFieldValue={setFieldValue}
                    index={index}
                    key={poltrona.idPoltrona}
                  />
                ))
              )}
            </FieldArray>

          </div>
          <div className={clsx(style.form__footer)}>
            <PrimaryButton type="submit" label={buttonText} fullWidth />
          </div>
        </Form>
      )}
    </Formik>
  );
}

export default PoltroneForm;
